import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { uniqBy } from 'lodash';

import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import {
	setAlertActionCreator,
} from 'plugins/store/reducers/common.reducer';
import { createAppointment } from 'services/appointment.service';
import { getContactCentersList } from 'services/contact-center.service';
import { getCustomNotifications } from 'services/custom-notifications.service';
import layoutNames from 'utils/enums/layout-names.enum';

import withForm from 'hoc/withForm';
import SnackMessage from 'components/Snackbar/SnackMessage';
import ScheduledCallForm from 'components/Scheduler/ScheduledCallForm';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import RouteLeavingGuard from 'components/RouteLeavingGuard/RouteLeavingGuard';

class CreateScheduledCall extends Component {
	state = {
		callCenterOptions: [],
		defaults: {
			callPurpose: '',
			dateTime: null,
			callDuration: null,
			reminder: null,
			callTo: null,
			callCenter: null,
		},
		customCallPurposeOptions: [],
		allCustomCallPurposes: [],
	}

	availableDurations = [15, 30, 45];
	availableReminders = [5, 10, 15];

	prepareCallCenterProperties = async () => {
		const callCenters = await getContactCentersList();
		const sortedCallCenters = callCenters
			.sort((a, b) => {
				if (a.name > b.name) {
					return 1;
				}
				if (a.name < b.name) {
					return -1;
				}
				return 0;
			});
		this.setState({
			callCenterOptions: sortedCallCenters,
		});
	};

	prepareCustomCallPurposes = async () => {
		const notifications = await getCustomNotifications();
		const validNotifications =
			uniqBy(
				notifications
					.filter((item) => item.customNotification),
				'customNotification');
		this.setState({
			customCallPurposeOptions: validNotifications,
			allCustomCallPurposes: notifications,
		});
	};

	componentDidMount() {
		this.props.setPageHeaderText('Create Appointment');
		this.prepareCallCenterProperties();
		this.prepareCustomCallPurposes();
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	onSubmit = async (data, resetCallBack) => {
		const { history, enqueueSnackbar } = this.props;
		try {

			const preparedDate = moment(data.dateTime).set({ second: 0, millisecond: 0 });

			const newAppointment = {
				type: "Call",
				status: "Not Confirmed",
				startTime: preparedDate.toISOString(),
				callPurpose: data.callPurpose?.customNotification,
				callDuration: data.callDuration,
				preCallReminderInterval: data.reminder,
				callToPhoneNumber: data.callTo.phoneNumber,
				callCenterId: data.callCenter._id,
			};

			await createAppointment(newAppointment);
			resetCallBack();
			history.replace({
				pathname: `/${layoutNames.portal}/scheduler`,
			});
		} catch (e) {
			enqueueSnackbar(e.resolvedErrorMessage, {
				content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
			});
		}
	}

	onError = () => {
		const { enqueueSnackbar } = this.props;
		const errorMessage = ['Appointment not saved.', 'Due to validation error(s)'];
		enqueueSnackbar(errorMessage, {
			content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
		});
	}

	render() {
		const {
			history,
			formMethods,
			formMethods: {
				formState: {
					isDirty,
				},
			},
		} = this.props;

		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardBody>
							<ScheduledCallForm
								formMethods={formMethods}
								customCallPurposeOptions={this.state.customCallPurposeOptions}
								callCenterOptions={this.state.callCenterOptions}
								onSubmit={this.onSubmit}
								onError={this.onError}
								isEdit={false}
								defaults={this.state.defaults}
							/>

							<RouteLeavingGuard
								when={isDirty}
								navigate={path => history.push(path)}
								shouldBlockNavigation={() => {
									if (isDirty) {
										return true;
									}
									return false
								}}
							/>

						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		currentUserEmail: state.auth.auth?.email
	};
};

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(setAlertActionCreator, dispatch),
	setPageHeaderText: bindActionCreators(setPageHeaderTextActionCreator, dispatch),
});

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withSnackbar,
	withForm,
	withRouter
)(CreateScheduledCall);
